import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html'
})
export class SearchInputComponent {
  @Input() label: string = 'Search';
  @Input() placeholder: string = 'Enter value';
  @Input() tooltip: string = 'Press Enter to search';
  @Input() inputId: string = 'searchByInput'; // shared default ID

  @Output() search = new EventEmitter<string>();
  @Output() cleared = new EventEmitter<void>();

    value: string = '';
  
      onEnter() {
    this.search.emit(this.value.trim());
  }

   clear() {
    this.value = '';
    this.cleared.emit(); // parent decides what to do (e.g., reload data)
  }

}
